import styled from 'styled-components';

const Bold = styled.div`
  font-weight: bold;
`;

export default Bold;
